import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-check",
  "use": "rt-portal-check-usage",
  "viewBox": "-791 -231 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-791 -231 1024 1024\" id=\"rt-portal-check\">\r\n<path d=\"M121-39H51.1C41.3-39,32-34.5,26-26.9l-412.3,519.2l-197.7-249c-6.1-7.7-15.3-12.1-25.1-12.1H-679c-6.7,0-10.4,7.7-6.3,12.8\r\n\tl273.9,344.9c12.8,16.1,37.4,16.1,50.3,0L127.3-26.3C131.4-31.3,127.7-39,121-39L121-39z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/check.svg
// module id = 1838
// module chunks = 137